import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'

import useTitle from 'common/use-title'
import OverviewRoute from './Overview'
import ColumnMapperRoute from './ColumnMapper'
import ReportContextProvider from './ReportContextProvider'

const EndOfCycleReportRoute = ({ mountPath }) => {
  useTitle('Scoir - End of Cycle Report')
  return (
    <ReportContextProvider>
      <Switch>
        <Route
          exact
          path={`${mountPath}/column-mapping`}
          component={ColumnMapperRoute}
        />
        <Route
          exact
          path={mountPath}
          component={OverviewRoute}
        />
      </Switch>
    </ReportContextProvider>
  )
}

EndOfCycleReportRoute.propTypes = {
  mountPath: PropTypes.string.isRequired,
}
export default EndOfCycleReportRoute
